import { createApiHook } from '../hooks';
import { bulkOperationsApiFactory } from './bulkOperationsApiFactory';

export const useBulkOperationsApi = createApiHook(bulkOperationsApiFactory);
